export default __webpack_public_path__ + "static/media/hero-leanSmall.bc59013f.jpg";